var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LottiePlayer',{staticStyle:{"width":"80px","height":"80px"},attrs:{"animation-data":_vm.LoadingJson,"loop":true}})}
var staticRenderFns = []

export { render, staticRenderFns }